import { AnchorHTMLAttributes, ReactNode } from 'react'

const ColoredLink = ({
  children,
  ...rest
}: {
  children: ReactNode
} & AnchorHTMLAttributes<HTMLAnchorElement>): JSX.Element => {
  return (
    <a
      className="font-medium text-petrol underline decoration-gold decoration-1 underline-offset-4 transition hover:decoration-petrol"
      {...rest}
    >
      {children}
    </a>
  )
}

export default ColoredLink
